<mat-progress-bar mode="indeterminate" class="w-full" *ngIf="loading$ | async; else display"></mat-progress-bar>
<ng-template #display>
  <as-split direction="horizontal" [useTransition]="true" [gutterSize]="6" class="h-full">
    <as-split-area [size]="30" class="h-full w-full relative">
      <form [formGroup]="form" (ngSubmit)="submit()" class="h-full w-full">
        <div class="editor-upper-part">
          <y42-target-column
            (click)="$event.stopPropagation()"
            [allowedColumnPattern]="allowedColumnPattern"
            [formGroup]="form"
            [maxLength]="30"
            [outputTypeName]="'outputType'"
            [label]="'Calculated Field Name'"
            formName="fieldName"
          >
          </y42-target-column>
        </div>
        <div class="editor-proposal overflow-auto" *ngIf="(usedLowCodeStrings?.size || 0) > 0">
          <div class="ml-3 font-medium text-gray-700 p-1 border-bottom">Previously Used:</div>
          <button
            mat-button
            type="button"
            class="w-full border-radius-0"
            (click)="setFunctionEditor(lowCode[1].lowCodeString)"
            *ngFor="let lowCode of usedLowCodeStringsEntries; trackBy: trackByIndex; let i = index"
          >
            <div class="flex">
              <div class="grow aligner-start">
                <y42-column-type-icon [type]="lowCode[1].outputType"></y42-column-type-icon
                ><span class="ml-1">{{ lowCode[0] }}</span>
              </div>
              <div class="grow truncate text-gray-700 font-normal">
                <code>{{ lowCode[1].lowCodeString }}</code>
              </div>
            </div>
          </button>
        </div>
        <div
          style="height: calc(100% - 170px)"
          [ngStyle]="{
            height: (usedLowCodeStrings.size || 0) > 0 ? 'calc(100% - 295px)' : 'calc(100% - 175px)'
          }"
          class="pt-3"
        >
          <y42-function-editor
            #functionEditor
            y42ColumnTypeCssStyles
            class="w-full"
            [allowedOutputTypes]="[form.controls.outputType.value | columnTypeToTsType]"
            [inputCode]="form.controls.lowCodeString.value"
            [sourceColumns]="columnConsts"
            [showAggregateFunctions]="true"
            (functionNameClicked)="openFunctionAgGrid($event)"
            (editorValueChanged)="form.controls.lowCodeString.setValue($event)"
            (validity)="validateEditor($event)"
          >
          </y42-function-editor>
        </div>
        <div class="flex w-full" style="height: 80px">
          <div class="grow p-2 aligner">
            <button mat-raised-button type="button" class="cancel-button" (click)="onNoClick()">Cancel</button>
          </div>
          <div class="grow p-2 aligner">
            <button
              [disabled]="(isValidEditor$ | async) === false || form.invalid"
              mat-raised-button
              color="primary"
              class="confirm-button"
              type="submit"
            >
              Apply
            </button>
          </div>
        </div>
      </form>
    </as-split-area>
    <as-split-area [size]="70">
      <y42-function-list-view
        #functionListView
        [showAggregateFunctions]="true"
        (addFunction)="addFunctionInEditor($event)"
      >
      </y42-function-list-view>
    </as-split-area>
  </as-split>
</ng-template>
